import request from '@/axios'
//course/create/2
export function courseWorkList (payload, customer_id, page) {
  return request({
    url:`/V1/ClientUser/assignment_builder/list/${customer_id}?page=${page}`,
    method:'POST',
    data:payload
  })
}

export function courseWorkDetails (customer_id, assignment_builder__user_id, payload = null) {
  return request({
    url:`/V1/ClientUser/assignment_builder/courseWork/${customer_id}/${assignment_builder__user_id}`,
    method:'POST',
    data:payload
  })
}

export function courseWorkSubmit (customer_id, assignment_builder_id, payload = null) {
  return request({
    url:`V1/ClientUser/assignment_builder/submitAnswers/${customer_id}/${assignment_builder_id}`,
    method:'POST',
    data:payload
  })
}

export function statusChng (customer_id, assignment_builder_user_id, payload) {
  return request({
    url:`V1/ClientUser/assignment_builder/status/${customer_id}/${assignment_builder_user_id}`,
    method: 'POST',
    data: payload
  })
}